import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../modules/auth/login";
import Dashboard from "../modules/dashboard";
import FieldForceDesignationCreate from "../modules/field-force/designations/fieldForceDesignationCreate";
import FieldForceDesignationEdit from "../modules/field-force/designations/fieldForceDesignationEdit";
import FieldForceDesignationView from "../modules/field-force/designations/fieldForceDesignationView";
import FieldForceCreate from "../modules/field-force/fieldForceCreate";
import FieldForceEdit from "../modules/field-force/fieldForceEdit";
import FieldForceList from "../modules/field-force/fieldForcetable";
import FieldForceView from "../modules/field-force/fieldForceView";
import ProductCreate from "../modules/products/productCreate";
import ProductDetail from "../modules/products/productDetail";
import ProductList from "../modules/products/productList";
import ProductVersionHistory from "../modules/products/productVersionHistory";
import ProductVersionHistoryView from "../modules/products/productVesrionHistoryView";
import PrivateRoute from "./privateRoute";
import ProtectedRoute from "./protectedRoute";
import FieldForceDesignationList from "../modules/field-force/designations/fieldForceDesignationList";
import FieldForceVersionHistory from "../modules/field-force/fieldForceVersionHistory";
import FieldForceVersionHistoryView from "../modules/field-force/fieldForceVersionHistoryView";
import SuperUserList from "../modules/superUsers/superUserList";
import SuperUserDetail from "../modules/superUsers/superUserDetail";
import SuperUserCreate from "../modules/superUsers/superUserCreate";
import SuperUserEdit from "../modules/superUsers/superUserEdit";
import SuperUserVersionHistory from "../modules/superUsers/superUserVersionHistory";
import SuperUserVersionHistoryView from "../modules/superUsers/superUserVersionHistoryView";
import SuperUserRoleList from "../modules/superUsers/superUserRole/superUserRoleList";
import SuperUserRoleDetail from "../modules/superUsers/superUserRole/superUserRoleDetail";
import SuperUserRoleCreate from "../modules/superUsers/superUserRole/superUserRoleCreate";
import SuperUserRoleEdit from "../modules/superUsers/superUserRole/superUserRoleEdit";
import SuperUserRoleVersionHistory from "../modules/superUsers/superUserRole/superUserRoleVersionHistory";
import SuperUserRoleVersionHistoryView from "../modules/superUsers/superUserRole/superUserRoleVersionHistoryView";
import ManageOrderDetail from "../modules/manageOrders/manageOrderDetail";
import ManageOrderList from "../modules/manageOrders/manageOrderList";
import CustomerList from "../modules/customers/onboarded-doctors/customerList.js";
import CustomerView from "../modules/customers/onboarded-doctors/customerView.js";
import CustomerVersionHistory from "../modules/customers/onboarded-doctors/customerVersionHistory.js";
import CustomerVersionHistoryDetail from "../modules/customers/onboarded-doctors/customerVersionHistoryDetail.js";

import DistributorList from "../modules/distributor/distributorList";
import DistributorDetail from "../modules/distributor/distributorDetail";
import PageNotFound from "../modules/pageNotFound/pageNotFound";
import FAQ from "../modules/faq/faq";
import Support from "../modules/faq/support";
import Settings from "../modules/settings/settings";
import { ToastContainer } from "react-toastify";
import FieldForceDesignationVersionList from "../modules/field-force/designations/fieldForceDesignationVersionList";
import FieldForceDesignationVersionView from "../modules/field-force/designations/fieldForceDesignationVersionView";
import CFAList from "../modules/CFA/cfa-list";
import CFACreate from "../modules/CFA/cfa-create";
import CFAEdit from "../modules/CFA/cfa-edit";
import CFAVersionHistoryList from "../modules/CFA/cfa-version-history-list";
import CFADetail from "../modules/CFA/cfa-detail";
import CFAVersionHistoryView from "../modules/CFA/cfa-version-history-view";
import FieldForceHeadQuarter from "../modules/field-force/head-quarter/fieldForceHeadQuarterList";
import FieldForceHeadQuarterCreate from "../modules/field-force/head-quarter/fieldForceHeadQuarterCreate";
import FieldForceHeadQuarterEdit from "../modules/field-force/head-quarter/fieldForceHeadQuarterEdit";
import FieldForceHeadQuarterView from "../modules/field-force/head-quarter/fieldForceHeadQuarterView";
import FieldForceHeadQuarterVersionList from "../modules/field-force/head-quarter/fieldForceHeadQuarterVersionList";
import FieldForceHeadQuarterVersionView from "../modules/field-force/head-quarter/fieldForceHeadQuarterVersionView";
import FieldForceAdminView from "../modules/field-force/admin/fieldForceAdminView";
import FieldForceAdminEdit from "../modules/field-force/admin/fieldForceAdminEdit";
import ProductEdit from "../modules/products/productEdit";
import DistributorOrderView from "../modules/distributor/distributorOrderView";
import Redirected from "../modules/redirected/Redirected";
import ForgotPassword from "../modules/auth/ForgotPassword";
import ResetPassword from "../modules/auth/ResetPassword";
import PasswordChanged from "../modules/auth/PasswordChanged";
import PasswordMailSent from "../modules/auth/PasswordMailSent";
import CreateNewPassword from "../modules/auth/CreateNewPassword";
import NewPasswordChanged from "../modules/auth/NewPasswordChanged";
import PrivacyPolicy from "../modules/static-pages/privacy-policy";
import TermsCondition from "../modules/static-pages/termsAndCondition";
import Analytics from "../modules/analytics/Analytics";
import DivisionList from "../modules/Divisions/divisionList";
import DivisionView from "../modules/Divisions/divisionView";
import DivisionCreate from "../modules/Divisions/divisionCreate";
import DivisionEdit from "../modules/Divisions/divisionEdit";
import PrivacyPolicyView from "../modules/settings/PrivacyPolicyView";
import PrivacyPolicyEdit from "../modules/settings/PrivayPolicyEdit";
import TermsConditionView from "../modules/settings/TermsConditionView";
import TermsConditionEdit from "../modules/settings/TermsConditionEdit";
import SettingsAccount from "../modules/settings/SettingsAccount";

import CustomerVerificationList from "../modules/support/customerVerification/customerVerificationList";
import CustomerVerificationView from "../modules/support/customerVerification/customerVerificationView";
import PurchaseOrderList from "../modules/purchase-order/purchase-order-list";
import DistributorCreate from "../modules/distributor/onboarding-distributors/distributor-create";
import DistributorOnboardningList from "../modules/distributor/onboarding-distributors/onboardingdistributorList";
import DistributorOnboardningDetail from "../modules/distributor/onboarding-distributors/onboardingDistributorDetail";
import ProductOfferRequestList from "../modules/customers/productRequests/productRequestList.js";
import ProductOfferRequestView from "../modules/customers/productRequests/productRequestView.js";

import CustomerPharmacyList from "../modules/customers/onboarded-pharmcay/pharmacyList.js";
import CustomerPharmacyView from "../modules/customers/onboarded-pharmcay/customerPharmacyView.js";
import CustomerPharmacyVersionHistory from "../modules/customers/onboarded-pharmcay/customerPharmacyVersionHistory.js";
import CustomerPharmacyVersionHistoryDetail from "../modules/customers/onboarded-pharmcay/customerVersionHistoryDetail.js";
import PharmacySubscribeRequestList from "../modules/customers/onboarding-pharmacy/onboardingPharmacyList.js";
import SubscribeRequestPharmacyView from "../modules/customers/onboarding-pharmacy/onboardingPharmacyView.js";
import PharmacyProductOfferRequestList from "../modules/customers/productRequestsPharmacy/pharmacyProductRequestList.js";
import PharmacyProductOfferRequestView from "../modules/customers/productRequestsPharmacy/pharmacyProductRequestView.js";
import OnboardingDoctorsList from "../modules/customers/onboarding-doctors/onboardingDcotorList.js";
import OnboardingDoctorView from "../modules/customers/onboarding-doctors/onboardingDoctorView.js";
import CustomerSubscribeRequestList from "../modules/customers/customer-subscribe-request/customerSubscrbeRequestList.js";
import CustomerSubscribeRequestView from "../modules/customers/customer-subscribe-request/customerSubscribeRequestView.js";
import AiFlaggedInvoiceList from "../modules/invoice-verification-v2/ai-flagged-invoices/ai-flagged-invoice-list.js";
import AiFlaggedInvoiceView from "../modules/invoice-verification-v2/ai-flagged-invoices/ai-flagged-invoice-view.js";
import AiInvoiceVerifiedList from "../modules/invoice-verification-v2/ai-verified-invoice/ai-verified-invoice-list.js";
import AiVerifiedInvoiceView from "../modules/invoice-verification-v2/ai-verified-invoice/ai-verified-invoice-view.js";
import PendingInvoiceList from "../modules/invoice-verification-v2/pending-invoice/pending-invoice-list.js";
import PendingInvoiceView from "../modules/invoice-verification-v2/pending-invoice/pending-invoice-view.js";
import RejectedInvoiceList from "../modules/invoice-verification-v2/rejected-invoices/rejected-invoice-list.js";
import RejectedInvoiceView from "../modules/invoice-verification-v2/rejected-invoices/rejected-invoice-view.js";
import InvoiceVerifiedList from "../modules/invoice-verification-v2/verified-invoice/verified-invoice-list.js";
import VerifiedInvoiceView from "../modules/invoice-verification-v2/verified-invoice/verified-invoice-view.js";

const MainRoute = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/*" element={<PageNotFound />} />
          <Route path="/admin-login/:id" element={<Redirected />} />
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/analytics" element={<Analytics />} />

            <Route path="/product" element={<ProductList />} />
            <Route path="/product/view/:id" element={<ProductDetail />} />
            <Route path="/product/create" element={<ProductCreate />} />
            <Route path="/product/edit/:id" element={<ProductEdit />} />
            <Route
              path="/product/version-history"
              element={<ProductVersionHistory />}
            />
            <Route
              path="/product/version-history-detail/:id"
              element={<ProductVersionHistoryView />}
            />

            <Route path="/division" element={<DivisionList />} />
            <Route path="/division/view/:id" element={<DivisionView />} />
            <Route path="/division/create" element={<DivisionCreate />} />
            <Route path="/division/edit/:id" element={<DivisionEdit />} />

            <Route
              path="/field-force/admin/view"
              element={<FieldForceAdminView />}
            />
            <Route
              path="/field-force/admin/edit"
              element={<FieldForceAdminEdit />}
            />
            <Route path="/field-force/user" element={<FieldForceList />} />
            <Route
              path="/field-force/user/create"
              element={<FieldForceCreate />}
            />
            <Route
              path="/field-force/user/view/:id"
              element={<FieldForceView />}
            />
            <Route
              path="/field-force/user/edit/:id"
              element={<FieldForceEdit />}
            />

            <Route
              path="/field-force/user/version-history"
              element={<FieldForceVersionHistory />}
            />
            <Route
              path="/field-force/user/version-history-detail/:id"
              element={<FieldForceVersionHistoryView />}
            />
            <Route
              path="/field-force/designation"
              element={<FieldForceDesignationList />}
            />
            <Route
              path="/field-force/designation/create"
              element={<FieldForceDesignationCreate />}
            />
            <Route
              path="/field-force/designation/edit/:id"
              element={<FieldForceDesignationEdit />}
            />
            <Route
              path="/field-force/designation/view/:id"
              element={<FieldForceDesignationView />}
            />
            <Route
              path="/field-force/designation/version-history"
              element={<FieldForceDesignationVersionList />}
            />
            <Route
              path="/field-force/designation/version-history-detail/:id"
              element={<FieldForceDesignationVersionView />}
            />
            <Route
              path="/field-force/head-quarter"
              element={<FieldForceHeadQuarter />}
            />
            <Route
              path="/field-force/head-quarter/create"
              element={<FieldForceHeadQuarterCreate />}
            />
            <Route
              path="/field-force/head-quarter/edit/:id"
              element={<FieldForceHeadQuarterEdit />}
            />
            <Route
              path="/field-force/head-quarter/view/:id"
              element={<FieldForceHeadQuarterView />}
            />
            <Route
              path="/field-force/head-quarter/version-list"
              element={<FieldForceHeadQuarterVersionList />}
            />
            <Route
              path="/field-force/head-quarter/version-view/:id"
              element={<FieldForceHeadQuarterVersionView />}
            />

            <Route path="/super-user/user" element={<SuperUserList />} />
            <Route
              path="/super-user/user/view/:id"
              element={<SuperUserDetail />}
            />
            <Route
              path="/super-user/user/create"
              element={<SuperUserCreate />}
            />
            <Route
              path="/super-user/user/edit/:id"
              element={<SuperUserEdit />}
            />
            <Route
              path="/super-user/user/version-history"
              element={<SuperUserVersionHistory />}
            />
            <Route
              path="/super-user/user/version-history-detail/:id"
              element={<SuperUserVersionHistoryView />}
            />

            <Route path="/super-user/role" element={<SuperUserRoleList />} />
            <Route
              path="/super-user/role/view/:id"
              element={<SuperUserRoleDetail />}
            />
            <Route
              path="/super-user/role/create"
              element={<SuperUserRoleCreate />}
            />
            <Route
              path="/super-user/role/edit/:id"
              element={<SuperUserRoleEdit />}
            />
            <Route
              path="/super-user/role/version-history"
              element={<SuperUserRoleVersionHistory />}
            />
            <Route
              path="/super-user/role/version-history-detail/:id"
              element={<SuperUserRoleVersionHistoryView />}
            />

            <Route path="/manage-order" element={<ManageOrderList />} />
            <Route
              path="/manage-order/view/:id"
              element={<ManageOrderDetail />}
            />

            <Route
              path="/customers/onboarded-doctors"
              element={<CustomerList />}
            />
            <Route
              path="/customers/onboarded-pharmacy"
              element={<CustomerPharmacyList />}
            />
            <Route
              path="/customers/onboarded-doctors/view/:id"
              element={<CustomerView />}
            />
            <Route
              path="/customers/onboarded-pharmacy/view/:id"
              element={<CustomerPharmacyView />}
            />
            <Route
              path="/customers/onboarded-doctors/version-history"
              element={<CustomerVersionHistory />}
            />
            <Route
              path={`/customers/onboarded-doctors/version-history-detail/:id`}
              element={<CustomerVersionHistoryDetail />}
            />
            <Route
              path="/customers/onboarded-pharmacy/version-history"
              element={<CustomerPharmacyVersionHistory />}
            />
            <Route
              path={`/customers/onboarded-pharmacy/version-history-detail/:id`}
              element={<CustomerPharmacyVersionHistoryDetail />}
            />
            <Route
              path="/customers/onboarding-doctor"
              element={<OnboardingDoctorsList />}
            />

            <Route
              path="/customers/onboarding-doctor/view/:id"
              element={<OnboardingDoctorView />}
            />

            <Route
              path="/customers/onboarding-pharmacy"
              element={<PharmacySubscribeRequestList />}
            />

            <Route
              path="/customers/onboarding-pharmacy/view/:id"
              element={<SubscribeRequestPharmacyView />}
            />

            <Route
              path="/customers/subscribe-request"
              element={<CustomerSubscribeRequestList />}
            />

            <Route
              path="/customers/subscribe-request/view/:id"
              element={<CustomerSubscribeRequestView />}
            />

            <Route
              path="/customers/product-offer-request"
              element={<ProductOfferRequestList />}
            />
            <Route
              path="/customers/product-offer-request/view/:id"
              element={<ProductOfferRequestView />}
            />

            <Route
              path="/customers/pharmacy-product-offer-request"
              element={<PharmacyProductOfferRequestList />}
            />
            <Route
              path="/customers/pharmacy-product-offer-request/view/:id"
              element={<PharmacyProductOfferRequestView />}
            />

            <Route
              path="/distributors/onboarded"
              element={<DistributorList />}
            />
            <Route
              path="/distributors/onboarding/create"
              element={<DistributorCreate />}
            />
            <Route
              path="/distributors/onboarded/view/:id"
              element={<DistributorDetail />}
            />
            <Route
              path="/distributors/onboarded/view/order-view"
              element={<DistributorOrderView />}
            />
            <Route
              path="/distributors/onboarding"
              element={<DistributorOnboardningList />}
            />
            <Route
              path="/distributors/onboarding/view/:id"
              element={<DistributorOnboardningDetail />}
            />

            <Route path="/cfa" element={<CFAList />} />
            <Route path="/cfa/create" element={<CFACreate />} />
            <Route path="/cfa/edit/:id" element={<CFAEdit />} />
            <Route path="/cfa/view/:id" element={<CFADetail />} />
            <Route
              path="/cfa/version-history"
              element={<CFAVersionHistoryList />}
            />
            <Route
              path="/cfa/version-history-view/:id"
              element={<CFAVersionHistoryView />}
            />

            <Route path="/purchase-order" element={<PurchaseOrderList />} />

            <Route path="/faq" element={<FAQ />} />

            <Route path="/contact-support" element={<Support />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/account" element={<SettingsAccount />} />
            <Route
              path="/settings/terms-condition/view"
              element={<TermsConditionView />}
            />
            <Route
              path="/settings/terms-condition/edit"
              element={<TermsConditionEdit />}
            />

            <Route
              path="/settings/privacy-policy/view"
              element={<PrivacyPolicyView />}
            />
            <Route
              path="/settings/privacy-policy/edit"
              element={<PrivacyPolicyEdit />}
            />

            <Route
              path="/invoice-verification/ai-flagged-invoices"
              element={<AiFlaggedInvoiceList />}
            />
            <Route
              path="/invoice-verification/ai-flagged-invoices/view/:id"
              element={<AiFlaggedInvoiceView />}
            />
            <Route
              path="/invoice-verification/ai-verified-invoices"
              element={<AiInvoiceVerifiedList />}
            />
            <Route
              path="/invoice-verification/ai-verified-invoices/view/:id"
              element={<AiVerifiedInvoiceView />}
            />
            <Route
              path="/invoice-verification/pending-invoices"
              element={<PendingInvoiceList />}
            />
            <Route
              path="/invoice-verification/pending-invoices/view/:id"
              element={<PendingInvoiceView />}
            />
            <Route
              path="/invoice-verification/rejected-invoices"
              element={<RejectedInvoiceList />}
            />
            <Route
              path="/invoice-verification/rejected-invoices/view/:id"
              element={<RejectedInvoiceView />}
            />
            <Route
              path="/invoice-verification/verified-invoices"
              element={<InvoiceVerifiedList />}
            />
            <Route
              path="/invoice-verification/verified-invoices/view/:id"
              element={<VerifiedInvoiceView />}
            />

            <Route
              path="/support/customer-verification"
              element={<CustomerVerificationList />}
            />
            <Route
              path="/support/customer-verification/view/:id"
              element={<CustomerVerificationView />}
            />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Login />} />
            <Route
              path="/create-new-password"
              element={<CreateNewPassword />}
            />
            <Route
              path="/new-password-created"
              element={<NewPasswordChanged />}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/password-mail-sent" element={<PasswordMailSent />} />
            <Route path="/reset-password/:id" element={<ResetPassword />} />
            <Route path="/password-changed" element={<PasswordChanged />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-condition" element={<TermsCondition />} />
          </Route>
        </Routes>
        <ToastContainer />
      </Router>
    </>
  );
};

export default MainRoute;
